export enum TimeUnit {
  hour= 'hour',
  day= 'day',
  month= 'month',
}
